import { AfterContentInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { DwComponent, DwComponentType } from '@devwareapps/devware-cap';

@DwComponent({
  name: 'Bunny PlayerJS Test Component',
  key: 'bunnyPlayerjsTestComponent',
  componentType: DwComponentType.pageComponent,
  isGlobal: true,
})
@Component({
  selector: 'app-bunny-playerjs-test',
  templateUrl: './bunny-playerjs-test.component.html',
  styleUrls: ['./bunny-playerjs-test.component.scss']
})
export class BunnyPlayerjsTestComponent implements OnInit, AfterContentInit {
  player: any;
  @Input() runSetupVideoOnInit: boolean = false;

  testVideoUrl: string = 'https://iframe.mediadelivery.net/embed/197133/dc48a09e-d9bb-420a-83d7-72dc2304c034';
  videoUrl: string; // = 'https://iframe.mediadelivery.net/embed/414225/b3d2d3a9-a736-44a2-8219-0938c7e8faae?autoplay=false&loop=false&muted=false&preload=true&responsive=true&cacheBust=1769731904083-63834630-3a61-43a5-9118-6a6b3a8cd01c';
  videoUrlSafe: SafeUrl;
  msgTapAdded: any;
  messageCount: any;
  constructor(private sanitizer: DomSanitizer, private hostElementRef: ElementRef) { }

  @ViewChild('bunny-stream-embed') playerIframe: ElementRef<HTMLIFrameElement>;
  @ViewChild('#player') playerElement: ElementRef;

  ngOnInit(): void {
    if (this.runSetupVideoOnInit) {
      setTimeout(() => {

        this.setupVideo

      }, 400);
    }
    this.setupVideo();
  }

  setupVideo() {
  //  this.videoUrl = 'https://iframe.mediadelivery.net/embed/414225/b3d2d3a9-a736-44a2-8219-0938c7e8faae?autoplay=false&loop=false&muted=false&preload=true&responsive=true&cacheBust=1769731904083-63834630-3a61-43a5-9118-6a6b3a8cd01c';
    this.videoUrl = 'https://iframe.mediadelivery.net/embed/414225/b3d2d3a9-a736-44a2-8219-0938c7e8faae';
    this.videoUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);
  }

  ngAfterContentInit(): void {
   
  }

  onIframeLoad() {
    this.setupPlayerJS('onIframeLoad');
  }

  setupPlayerJS(source: string) {
    if (!this.videoUrl) {
      return;
    }

    if (this.player) {
      return;
    }

    this.addMessageTap();

    // Create a PlayerJS instance with the 'bunny-stream-embed' element
    const playerjs = (window as any).playerjs;

    const iFrame = document.getElementById("bunny-stream-embed") as HTMLIFrameElement;
    
    if (this.player) {
            this.log(`PlayerJS already setup, skipping from Source: ${source}`);
      return;
    }

    if(!iFrame.src) {
          this.log(`Skiping IFrame setup: ${iFrame.src} from Source: ${source}`);
      return;
    }

    this.log(`Setting up PlayerJS with IFrame: ${iFrame.src} from Source: ${source}`);

    try {
      const player = new playerjs.Player(iFrame);

      this.player = player;
    } catch (error) {
      console.error("Error accessing IFrame element:", error);

      this.log("Error accessing IFrame element:");
      return;
    }

    // Event handler when the player is ready
    this.player.on('ready', () => {
      this.log("ready event");
    });

    // Event handler when the player is played
    this.player.on('play', () => {
      this.log("play");
    });

    // Event handler when the player is paused
    this.player.on('pause', () => {
      this.log("pause event");
    });

    // Event handler for time updates when the player is playing
    this.player.on('timeupdate', (data) => {
     // this.log("timeupdate (" + data + ")");
    });
  }

  
  addMessageTap() {
    if (this.msgTapAdded) return;
    this.msgTapAdded = true;

    window.addEventListener('message', (ev) => {
      // limit noise: only log mediadelivery origins
      const o = (ev.origin || '').toLowerCase();
      //if (!o.includes('mediadelivery.net')) return;

      if (!ev?.data?.length || ev.data.indexOf('player.js') === -1) {
        return;
      }

      this.log(`msg : ${safeTrim(ev.data)}`);
      this.messageCount++;

      // if ((this.messageCount - 1) % 60 !== 0) return;

      // this.dwPubSubService.emitDebug('Info', 'PJS - window.message', {
      //   origin: ev.origin,
      //   dataType: typeof ev.data,
      //   data: safeTrim(ev.data),
      //   messageCount: this.messageCount
      // });
    }, true);
  }

  play() {
    this.player.play();
  }

  pause() {
    this.player.pause();
  }

  seek() {
    this.player.getCurrentTime((currentTime) => {
      this.player.setCurrentTime(currentTime + 10);
    });
  }

  logData: string = ''

  // Function to log messages and update the log text area
  log(message) {
    //console.log(message);
    this.logData += `${message}\n`;
  }

}

function safeTrim(data: string, maxLength: number = 512): any {

  if (data?.length > maxLength) {
    return `${data.substring(0, maxLength)}... (truncated)`;
  }

  return data;

}
